module.exports = __webpack_public_path__ + "img/04-Cambridge-1.14691184.jpg";